export const urlApi = "https://suadesarrollo.azurewebsites.net";

export const creaSolicitud = urlApi + "/api/CreaSolicitud";
export const creaInstitucion = urlApi + "/api/CreaInstitucion";
export const creaGerente = urlApi + "/api/CrearGerente";
export const creaRepresentanteLegal = urlApi + "/api/CreaRepresentanteLegal";
export const CreaFechaVisitaSolicitud =
  urlApi + "/api/CreaFechaVisitaSolicitud ";
export const CreaSede = urlApi + "/api/CreaSede ";
export const CreaDetalleEstandar = urlApi + "/api/CreaDetalleEstandar";
export const creaSistemaCalidad = urlApi + "/api/CreaSistemaCalidad";
export const creaCapacidad = urlApi + "/api/CreaCapacidadInstalada";
export const CreaControlLegal = urlApi + "/api/CreaControlLegalSolicitud";
export const creaLiderSolicitud = urlApi + "/api/CreaLiderSolicitud";
export const detalleSolicitud =
  urlApi +
  "/api/ObtenerQSolicitudesDetalleInstitucionPorInstitucionId?InstitucionId=";
export const detalleSolicitudTodos =
  urlApi + "/api/ObtenerQSolicitudesDetalleInstitucion";
export const institucionPorId = urlApi + "/Api/ObtenerInstitucionesPorId?Id=";
export const obtenerServiciosTodos = urlApi + "/api/ObtenerServicios";
export const obtenerServiciosPorSolicitud =
  urlApi + "/api/ObtenerServiciosPorInstitucionId?InstitucionId=";
export const obtenerCapacidadInstalada =
  urlApi + "/api/ObtenerCapacidadInstalada";
export const capacidadPorSolicitud =
  urlApi + "/api/ObtenerCapacidadInstaladaPorInstitucionId?InstitucionId=";
export const obtenerDocumentacion =
  urlApi + "/api/ObtenerDocumentacionSolicitudes";
export const documentacionPorSolicitud =
  urlApi +
  "/api/ObtenerDocumentacionSolicitudesPorInstitucionId?InstitucionId=";

export const obtenerServiciosModalidadPorInstitucion =
  urlApi + "/api/ObtenerServicioModalidadPorInstitucionId?InstitucionId=";
export const obtenerServiciosModalidad =
  urlApi + "/api/ObtenerServicioModalidad";

export const obtenerMunicipio = urlApi + "/api/ObtenerMunicipios";
export const obtenerDepartamento = urlApi + "/api/ObtenerDepartamentos";
export const obtenerTipoInstitucion = urlApi + "/api/ObtenerTipoInstituciones";
export const obtenerGerentes = urlApi + "/api/QGerenteInstitucion";
export const gerentePorInstitucion =
  urlApi + "/api/QGerentePorInstitucionId?InstitucionId=";
export const obtenerTipoDocumento = urlApi + "/api/obtenerTipoDocumentos";
export const obtenerRepresentanteLegal =
  urlApi + "/api/ObtenerQRepresentanteLegalInstituciones";
export const representanteLegalPorInstitucion =
  urlApi + "/api/ObtenerQRepresentanteLegalPorInstitucionId?InstitucionId=";
export const obtenerFechaVisitaSolicitudes =
  urlApi + "/api/ObtenerFechaVisitaSolicitudes";
export const obtenerSolicitudes = urlApi + "/api/ObtenerSolicitudes";
export const obtenerInstituciones = urlApi + "/api/ObtenerInstituciones";
export const obtenerTipoSolicitud = urlApi + "/api/ObtenerTipoSolicitudes";
export const obtenerEspecialidades = urlApi + "/api/ObtenerEspecialidades";
export const obtenerSedes = urlApi + "/api/ObtenerSedes";
export const sedesPorInstitucionId =
  urlApi + "/api/ObtenerSedesPorInstitucionId?InstitucionId=";
export const obtenerNumeroTrabajadores =
  urlApi + "/api/ObtenerSolicitudTrabajadores";
export const ObtenerControlLegalSolicitud =
  urlApi + "/api/ObtenerControlLegalSolicitud";
export const ObtenerControlLegalSolicitudId =
  urlApi + "/api/ObtenerControlLegalSolicitudPorId";
export const obtenerServicioHospitalizacion =
  urlApi + "/api/ObtenerServicioHospitalizacionSolicitud";
export const obtenerServicioIntermedio =
  urlApi + "/api/ObtenerServicioCuidadoIntermedioSolicitud";
export const obtenerLiderSolicitudes = urlApi + "/api/ObtenerLiderSolicitudes";
export const trabajadoresPorInstitucion =
  urlApi + "/api/ObtenerSolicitudTrabajadoresPorInstitucionId?InstitucionId=";
export const GrupoAyBporInstitucion =
  urlApi + "/api/QIndicadorAyBInstitucionId?InstitucionId=";
export const GrupoAyB = urlApi + "/api/QIndicadorAyB";
export const MorbilidadTodos = urlApi + "/api/QIndicadorMorbilidad";
export const MorbilidadPorInstitucion =
  urlApi +
  "/api/ObtenerQIndicadoresMorbilidadPorInstitucionIdAno?InstitucionId=";
export const MortalidadTodos = urlApi + "/api/QIndicadorMortalidad";
export const MortalidadPorInstitucion =
  urlApi +
  "/api/ObtenerQIndicadoresMortalidadPorInstitucionIdAno?InstitucionId=";

export const guardarDocs = "https://localhost:3000/PruebaDocs";
